var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-center" },
        [
          _vm.loading
            ? _c("b-spinner", { staticClass: "mx-2", attrs: { large: "" } })
            : _vm._e(),
          _vm.loading ? _c("span", [_vm._v("Loading...")]) : _vm._e(),
        ],
        1
      ),
      !_vm.loading
        ? _c(
            "b-card",
            [
              !_vm.loading
                ? _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.editRawMaterial($event)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Raw Material Name*",
                                    "label-for": "mc-Raw Material-Supplier",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "mc-Raw Material-Supplier",
                                      placeholder: "Raw Material",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.rawmaterialsID.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.rawmaterialsID,
                                          "name",
                                          $$v
                                        )
                                      },
                                      expression: "rawmaterialsID.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Raw Material Code",
                                    "label-for": "mc-Raw Material-Code",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "mc-Raw Material-Code",
                                      readonly: "",
                                    },
                                    model: {
                                      value: _vm.rawmaterialsID.code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.rawmaterialsID,
                                          "code",
                                          $$v
                                        )
                                      },
                                      expression: "rawmaterialsID.code",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    "label-for": "mc-stock-threshold",
                                    label: "Low Stock Threshold*",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "form-label-group" },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "mc-stock",
                                          type: "text",
                                          placeholder: "Low Stock Threshold",
                                          readonly: "",
                                        },
                                        model: {
                                          value: _vm.rawmaterialsID.lowStock,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.rawmaterialsID,
                                              "lowStock",
                                              $$v
                                            )
                                          },
                                          expression: "rawmaterialsID.lowStock",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _vm.rawmaterialsID.category
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: "Category*",
                                        "label-for": "mc-Category",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          placeholder: "RMTest1",
                                          readonly: "",
                                        },
                                        model: {
                                          value:
                                            _vm.rawmaterialsID.category.name,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.rawmaterialsID.category,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "rawmaterialsID.category.name",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Sub Category",
                                    "label-for": "mc-subCategory",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "mc-subCategory",
                                      value: _vm.getSubCategoryNameById(
                                        _vm.rawmaterialsID.productCategorySubId
                                      ),
                                      readonly: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "UOM",
                                    "label-for": "mc-Uom",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: { placeholder: "Kg", readonly: "" },
                                    model: {
                                      value: _vm.uomName,
                                      callback: function ($$v) {
                                        _vm.uomName = $$v
                                      },
                                      expression: "uomName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Price (Rs)",
                                    "label-for": "Price (Rs)",
                                  },
                                },
                                [
                                  _vm.HasPermission(
                                    _vm.PermissionList.Inventory_Finance
                                  )
                                    ? _c("b-form-input", {
                                        attrs: {
                                          type: "text",
                                          id: "mc-Raw Material-Price",
                                          placeholder: "Raw Material Price",
                                          readonly: "",
                                        },
                                        model: {
                                          value:
                                            _vm.rawmaterialsID.purchasePrice,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.rawmaterialsID,
                                              "purchasePrice",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "rawmaterialsID.purchasePrice",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Preferred Supplier",
                                    "label-for": "mc-Supplier",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.suppliers,
                                      "value-field": "id",
                                      "text-field": "name",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.rawmaterialsID.supplierId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.rawmaterialsID,
                                          "supplierId",
                                          $$v
                                        )
                                      },
                                      expression: "rawmaterialsID.supplierId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "mb-2", attrs: { cols: "12" } },
                            [
                              _c(
                                "label",
                                { attrs: { for: "textarea-default" } },
                                [_vm._v("Raw Material Description")]
                              ),
                              _c("b-form-textarea", {
                                attrs: {
                                  id: "textarea-default",
                                  rows: "5",
                                  placeholder: "Description",
                                  readonly: "",
                                },
                                model: {
                                  value: _vm.rawmaterialsID.description,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.rawmaterialsID,
                                      "description",
                                      $$v
                                    )
                                  },
                                  expression: "rawmaterialsID.description",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { staticClass: "12" },
                            [
                              _c("CustomFieldsDetails", {
                                attrs: {
                                  ReadOnlyFields: true,
                                  AdditionalFields:
                                    _vm.rawmaterialsID.additionalFields,
                                  ModuleReference: "RawMaterial",
                                },
                                on: { onchange: _vm.additionalFieldChanges },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }